<template>
  <div class="row mt-2 g-3">
    <div class="col-12 col-lg-6 col-xl-3">
      <div
        role="button"
        class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
        style="height: 100%"
        @click="toggleDetailPemutakhiranJumlahPenerbitanIzin(true)"
      >
        <div class="d-flex align-items-center">
          <span class="widget-icon me-3" style="height: auto">
            <i class="fa fa-check-square text-primary" />
          </span>
          <h3 class="m-0">Jumlah Penerbitan Izin</h3>
        </div>
        <p class="fs-1 m-0">{{ dataPemutakhiran.jumlah_penerbitan_izin }}</p>
      </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-3">
      <div
        role="button"
        class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
        style="height: 100%"
        @click="toggleDetailPemutakhiranHabisMasaBerlaku(true)"
      >
        <div class="d-flex align-items-center">
          <span class="widget-icon me-3" style="height: auto">
            <i class="fa fa-hourglass-half text-primary" />
          </span>
          <h3 class="m-0">Habis Masa Berlaku</h3>
        </div>
        <p class="fs-1 m-0">{{ dataPemutakhiran.habis_masa_berlaku }}</p>
      </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-3">
      <div
        role="button"
        class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
        style="height: 100%"
        @click="toggleDetailPemutakhiranPencabutanKkprl(true)"
      >
        <div class="d-flex align-items-center">
          <span class="widget-icon me-3" style="height: auto">
            <i class="fa fa-file-excel-o text-primary" />
          </span>
          <h3 class="m-0">Pencabutan KKPRL</h3>
        </div>
        <p class="fs-1 m-0">{{ dataPemutakhiran.pencabutan }}</p>
      </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-3">
      <div
        role="button"
        class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
        style="height: 100%"
        @click="toggleDetailPemutakhiranPembatalanKkprl(true)"
      >
        <div class="d-flex align-items-center">
          <span class="widget-icon me-3" style="height: auto">
            <i class="fa fa-times text-primary" />
          </span>
          <h3 class="m-0">Pembatalan KKPRL</h3>
        </div>
        <p class="fs-1 m-0">{{ dataPemutakhiran.pembatalan }}</p>
      </div>
    </div>

    <DetailPemutakhiranJumlahPenerbitanIzin
      :show="showDetailPemutakhiranJumlahPenerbitanIzin"
      @close="toggleDetailPemutakhiranJumlahPenerbitanIzin"
      :filter-tahun="filterTahun"
    />
    <DetailPemutakhiranHabisMasaBerlaku
      :show="showDetailPemutakhiranHabisMasaBerlaku"
      @close="toggleDetailPemutakhiranHabisMasaBerlaku"
      :filter-tahun="filterTahun"
    />
    <DetailPemutakhiranPencabutanKkprl
      :show="showDetailPemutakhiranPencabutanKkprl"
      @close="toggleDetailPemutakhiranPencabutanKkprl"
      :filter-tahun="filterTahun"
    />
    <DetailPemutakhiranPembatalanKkprl
      :show="showDetailPemutakhiranPembatalanKkprl"
      @close="toggleDetailPemutakhiranPembatalanKkprl"
      :filter-tahun="filterTahun"
    />
  </div>
</template>

<script>
import DetailPemutakhiranHabisMasaBerlaku from '../DetailDashboard/DetailPemutakhiranHabisMasaBerlaku.vue'
import DetailPemutakhiranJumlahPenerbitanIzin from '../DetailDashboard/DetailPemutakhiranJumlahPenerbitanIzin/DetailPemutakhiranJumlahPenerbitanIzin.vue'
import DetailPemutakhiranPembatalanKkprl from '../DetailDashboard/DetailPemutakhiranPembatalanKkprl.vue'
import DetailPemutakhiranPencabutanKkprl from '../DetailDashboard/DetailPemutakhiranPencabutanKkprl.vue'

export default {
  components: {
    DetailPemutakhiranJumlahPenerbitanIzin,
    DetailPemutakhiranHabisMasaBerlaku,
    DetailPemutakhiranPencabutanKkprl,
    DetailPemutakhiranPembatalanKkprl,
  },
  props: ['dataPemutakhiran', 'filterTahun'],
  data() {
    return {
      showDetailPemutakhiranJumlahPenerbitanIzin: false,
      showDetailPemutakhiranHabisMasaBerlaku: false,
      showDetailPemutakhiranPencabutanKkprl: false,
      showDetailPemutakhiranPembatalanKkprl: false,
    }
  },
  methods: {
    toggleDetailPemutakhiranJumlahPenerbitanIzin(val) {
      this.showDetailPemutakhiranJumlahPenerbitanIzin = val
    },
    toggleDetailPemutakhiranHabisMasaBerlaku(val) {
      this.showDetailPemutakhiranHabisMasaBerlaku = val
    },
    toggleDetailPemutakhiranPencabutanKkprl(val) {
      this.showDetailPemutakhiranPencabutanKkprl = val
    },
    toggleDetailPemutakhiranPembatalanKkprl(val) {
      this.showDetailPemutakhiranPembatalanKkprl = val
    },
  },
}
</script>

<style scoped>
.h-auto {
  height: auto !important;
}

@media (min-width: 1200px) {
  .h-auto {
    height: 100% !important;
  }
}
</style>
